// App — top-level component. Owns the router and the global Shell
// (which wraps every route via <Outlet />).
//
// 11 routes per UI_SPEC §3.1 — Dashboard is the default landing at /
// because decision-2 (locked 2026-05-17) said to cut over completely from
// the old 2-column chat-canvas. No /chat legacy route is preserved.

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Shell } from "./components/Shell.js";
import DashboardView from "./views/DashboardView.js";
import GanttView from "./views/GanttView.js";
import WbsView from "./views/WbsView.js";
import CriticalPathView from "./views/CriticalPathView.js";
import DependencyNetworkView from "./views/DependencyNetworkView.js";
import RiskView from "./views/RiskView.js";
import EarnedValueView from "./views/EarnedValueView.js";
import ResourcesView from "./views/ResourcesView.js";
import WorkPackagesView from "./views/WorkPackagesView.js";
import CanonicalView from "./views/CanonicalView.js";
import HealthView from "./views/HealthView.js";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Shell />}>
          <Route path="/"                    element={<DashboardView />} />
          <Route path="/gantt"               element={<GanttView />} />
          <Route path="/wbs"                 element={<WbsView />} />
          <Route path="/critical-path"       element={<CriticalPathView />} />
          <Route path="/dependency-network"  element={<DependencyNetworkView />} />
          <Route path="/risk"                element={<RiskView />} />
          <Route path="/earned-value"        element={<EarnedValueView />} />
          <Route path="/resources"           element={<ResourcesView />} />
          <Route path="/work-packages"       element={<WorkPackagesView />} />
          <Route path="/canonical"           element={<CanonicalView />} />
          <Route path="/ops"                 element={<HealthView />} />
          <Route path="*"                    element={<DashboardView />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
